import {
  emailSchema,
  getDateRangeFromAge,
  getDateSchema,
  getMobilePhonePhSchema,
  getNameSchema,
} from '@breezeventures/web-ph-validators/zod-schemas';
import { requiredStringArray } from '@breezeventures/web-ph-validators/zod-utils';
import { z } from 'zod';

const baseAgentSchema = z.object({
  uiId: z.string(),
  firstName: getNameSchema({
    required: true,
    requiredMessage: 'First name is required',
  }),
  middleName: getNameSchema({
    required: true,
    requiredMessage: 'Middle name is required',
  }),
  lastName: getNameSchema({
    required: true,
    requiredMessage: 'Last name is required',
  }),
  birthDate: getDateSchema({
    required: true,
    requiredMessage: 'Birth date is required',
    ...getDateRangeFromAge({ minAge: 7, maxAge: 90 }),
    rangeMessage: 'Enter a valid date of birth',
  }),
  email: emailSchema,
  mobilePhone: getMobilePhonePhSchema({
    required: true,
  }),
  assignedPointsOfSales: requiredStringArray('Add stores'),
});

export function getAgentSchema(posIds: string[]) {
  const posIdSet = new Set(posIds);
  return baseAgentSchema.refine(
    (data) => data.assignedPointsOfSales.every((id) => posIdSet.has(id)),
    {
      message:
        'Some selected stores are no longer available. Please, update the selection.',
      path: ['assignedPointsOfSales'],
    }
  );
}

export type AgentFormValues = z.infer<ReturnType<typeof getAgentSchema>>;
